module.exports = () => ({
  ".hero-group-content": {
    "@apply ds-relative ds-flex ds-flex-col ds-justify-center ds-items-center": 1,
  },
  ".hero-group-cta": {
    "@apply ds-flex ds-flex-col sm:!ds-flex-row ds-flex-wrap ds-justify-center ds-gap-xl ds-gap-y-xl sm:!ds-gap-y-2xl": 1,
    "& > *": { "@apply ds-m-0": 1 },
  },
  ".hero-group-preamble": {
    "@apply ds-pb-xl sm:!ds-pb-3xl ds-box-content ds-max-w-[760px]": 1,
    "@apply ds-flex ds-flex-col ds-justify-center ds-items-center ds-gap-y-xl": 1,
    "@apply ds-text-center ds-text-xl ds-leading-base sm:!ds-text-3xl sm:!ds-leading-xl": 1,
  },

  ".hero-group-loud": {
    ".hero-group-content": {
      "@apply ds-pt-3xl ds-pb-2xl sm:!ds-pt-[116px] sm:!ds-pb-3xl ds-gap-y-xl sm:!ds-gap-y-2xl": 1,
    },
    ".hero-group-heading": {
      // 2.75rem=44px, 4.5rem=72px
      "@apply ds-text-[2.75rem] ds-leading-[48px] sm:!ds-text-[4.5rem] sm:!ds-leading-[84px] ds-text-center ds-max-w-[1024px]": 1,
      "&:only-child": { "@apply ds-pb-[14px] sm:!ds-pb-3xl": 1 },
    },
    ".hero-group-preamble": { "@apply ds-pt-xl sm:!ds-pt-3xl": 1 },
  },

  ".hero-group-quiet": {
    ".hero-group-content": {
      "@apply ds-pt-2xl ds-pb-xl sm:!ds-py-3xl ds-gap-y-2xl sm:!ds-gap-y-3xl": 1,
    },
    ".hero-group-heading": {
      "@apply ds-text-5xl ds-leading-2xl sm:!ds-text-7xl sm:!ds-leading-4xl ds-text-center ds-max-w-[1024px]": 1,
      "&:only-child": { "@apply ds-pb sm:!ds-pb-0": 1 },
    },
    ".hero-group-preamble": { "@apply ds-pt-0": 1 },
  },
});
